import Copy from '@/components/svg/Copy';
import { getAssetPlatformLink, getPlatformLink } from '@/lib/platform';
import { ShortenAddr } from '@/lib/Shorten';
import Toast from '@/lib/toast';
import { useEffect, useRef, useState } from 'react';
import useUserStore from 'store/user';
import ImgAsset1 from 'assets/images/assetfimini_link_asset.png';
import ImgAsset2 from 'assets/images/20250609_assetfimini_link02.png';
import { useNavigate } from 'react-router-dom';
export default function Profile() {
  // store
  const { telegramId, walletAddress, myReferralCode, ids } = useUserStore();

  // state
  const profile_list = [
    { id: 'Telegram ID', value: telegramId },
    { id: 'Wallet Address', value: walletAddress, msg: 'Wallet address copied!' },
    { id: 'My Referral Code', value: myReferralCode, msg: 'Your referral code is copied!' },
  ];
  const [showToast, setShowToast] = useState(false);
  const [toastMsg, setToastMsg] = useState('');

  const navigate = useNavigate();
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  useEffect(() => {
    (async () => {
      if (!ids.pointId) {
        navigate('/');
        return;
      }
    })();

    return () => {};
  }, []);
  useEffect(() => {
    if (toastMsg) {
      setShowToast(true);
      timerRef.current = setTimeout(() => {
        setShowToast(false);
        setToastMsg('');
      }, 3000);
    }

    return () => {};
  }, [toastMsg]);

  // method

  const handlePlatformLinkClick = (value: string) => {
    const link = value === 'asset' ? getAssetPlatformLink() : getPlatformLink();
    window.open(link, '_blank');
  };

  return (
    <div className="flex h-full flex-col">
      <div className="px-[16px] py-[20px]">
        <div className="mb-[10px] flex items-center gap-[5px]">
          <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-[#FF4F19]" />
          <h3 className="text-[15px] font-[800] text-[#FF4F19]">PROFILE</h3>
        </div>

        <div className="flex flex-col gap-[7px]">
          {profile_list.map((profile) => (
            <div
              key={profile.id}
              className="flex items-center justify-between rounded-lg border-t-2 border-t-[#B2B2B2] bg-white px-[10px] py-[14px] text-[13px] text-[#4D4840]"
            >
              <span className="text-[12px] font-bold text-[#4F4F4F]">{profile.id}</span>

              <div className="flex items-center gap-[6px]">
                <span className="text-[12px] text-[#4F4F4F]">
                  {profile.id === 'Wallet Address' ? ShortenAddr(profile.value) : profile.value}
                </span>
                {profile.msg && (
                  <Copy
                    value={profile.value}
                    className="h-8 w-8 cursor-pointer text-gray-500"
                    setToastMsg={setToastMsg}
                    toastMsg={profile.msg}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-auto flex flex-col items-center gap-[6px] border-t-4 border-[#B2B2B2] bg-white p-[16px] text-[16px]">
        <div className="w-full flex-1">
          <img
            src={ImgAsset1} // 원하는 이미지 경로
            alt="에셋파이"
            className="h-auto w-full cursor-pointer rounded-lg"
            onClick={() => handlePlatformLinkClick('asset')}
          />
        </div>
        <div className="w-full flex-1">
          <img
            src={ImgAsset2} // 원하는 이미지 경로
            alt="셔플 설치"
            className="h-auto w-full cursor-pointer rounded-lg"
            onClick={() => handlePlatformLinkClick('shuffle')}
          />
        </div>
      </div>
      {showToast && (
        <Toast
          message={toastMsg}
          duration={3} // 초 단위
          onClose={() => setShowToast(false)}
        />
      )}
    </div>
  );
}
